import { useTranslation } from 'next-i18next'
import { NextSeo } from 'next-seo'
import { useMemo } from 'react'

import { type Locale } from '@/generated/graphql-types'
import { useLocale } from '@/hooks/useLocale'
import { getAbsoluteUrl, getBaseUrl } from '@/utils/url'

import { type GetSeoLocationResponse } from '../useHomepageGetSeoUrl'

type HomepageSeoMetadataProps = {
  seoLocation: GetSeoLocationResponse
  locationId: number
  locationName: Locale
}

export const HomepageSeoMetadata = ({
  locationId,
  locationName,
  seoLocation,
}: HomepageSeoMetadataProps) => {
  const { apiLocale } = useLocale()
  const { t } = useTranslation('home')

  const title =
    locationId && locationName
      ? t('meta.title.location', { location: locationName[apiLocale] })
      : t('meta.title') // fallback for Canada or no location

  const description =
    locationId && locationName
      ? t('meta.description.location', { location: locationName[apiLocale] })
      : t('meta.description') // fallback for Canada or no location

  const baseUrl = useMemo(() => getBaseUrl(), [])
  const canonicalUrl =
    seoLocation.seoCurrentName === 'canada' && seoLocation.id === 0
      ? baseUrl
      : `${baseUrl}/h-${seoLocation.seoCurrentName}/${seoLocation.id}`

  return (
    <NextSeo
      title={title}
      description={description}
      canonical={canonicalUrl}
      openGraph={{
        title: 'Kijiji Canada',
        description: description,
        siteName: 'Kijiji',
        images: [
          {
            url: getAbsoluteUrl('/next-assets/images/fb_desktop.jpg'),
          },
        ],
        type: 'website',
      }}
    />
  )
}
